import { Controller } from '@hotwired/stimulus'
import { loadFilePond } from '../models/filepond_loader'

export default class StripPostController extends Controller {
  static targets = ['postList']

  async connect() {
    this.FilePond = await loadFilePond()
  }

  post_form(e) {
    $(e.target).atwho({
      at: '@',
      data: '/posts/get_mention_users',
      displayTpl: '<li>${name}</li>',
      insertTpl: ' ${display_name} ',
      delay: 400
    })

    $('.post_submit').removeClass('disabled')
    $('.plus_button').removeClass('d-none').show()

    if ($('#shareRecipeModal').is(':visible')) {
      let field = $('#shareRecipeModal')
        .find('form')
        .find(".post-field:not(':focus')")
        .each(function (index, element) {})
      $('#shareRecipeModal')
        .find('form')
        .find(document.activeElement)
        .parent('div')
        .parent('div')
        .find('.post_media')
        .removeClass('d-none')
      field.parent('div').parent('div').find('.post_media').addClass('d-none')
    } else {
      $(document.activeElement)
        .parent('div')
        .parent('div')
        .find('.post_media')
        .removeClass('d-none')
    }
  }

  open_modal(e) {
    $('#sentLoader').toggleClass('d-none')
    $(e.target).find('svg').toggleClass('d-none')
    let truck_modal = document.getElementById('addPostModal')
    const modal = bootstrap.Modal.getInstance(truck_modal)
    if (modal._isShown) return

    $('#sharePostOptions').remove()
    let extras = e.target.dataset.extras || ''
    e.preventDefault()
    let index = e.currentTarget.dataset.index
    let form = document.getElementById('new_post_form')
    let extraHtml = document.createElement('input')
    extraHtml.type = 'hidden'
    extraHtml.name = 'post[extra_description]'
    extraHtml.value = extras
    form.append(extraHtml)
    if ($(form).valid()) {
      form.requestSubmit()
      form.addEventListener('turbo:submit-end', async (e) => {
        e.stopPropagation()
        modal.show()
        let target = document.getElementById('post_medias_' + index)
        let filePound = this.FilePond.find(target)
        let files = filePound.getFiles()

        if (files.length > 0) {
          setTimeout(() => {
            let firstRecord = $(truck_modal)
              .find('.images')
              .first()
              .find('div')
              .first()
            console.log($(truck_modal).find('.images').first())
            let filePond1 = this.FilePond.find(firstRecord[0])
            for (const fileItem of files) {
              filePond1.addFile(fileItem.file)
            }
            $('#sentLoader').toggleClass('d-none')
            $(e.target).find('svg').toggleClass('d-none')
          }, 1000)
        }
      })
    } else {
      $(form)[0].querySelector('#not_ignore').value = ''
      delete $(form)[0].querySelector('#not_ignore')?.dataset?.fired
    }
  }

  addReplyForm(e) {
    $(e.currentTarget)
      .closest('.comment-list')
      .find('.commentReply')
      .removeClass('d-none')
    $(e.currentTarget)
      .closest('.comment-list')
      .find('.commentReply')
      .find('.comment_field')
      .focus()
    $(e.currentTarget)
      .closest('.comment-list')
      .find('.commentReply')
      .find('.comment_field')
      .val('')
  }

  hideReplyForm(e) {
    $(e.currentTarget).closest('.commentReply').addClass('d-none')
    const pond = this.FilePond.find(
      $(e.currentTarget)
        .closest('.comment-list')
        .find('.commentReply')
        .find('.filepond-transparent')[0]
    )
    // remove the GIF attachment from media field after click on post button of reply comment
    if (pond) pond.removeFile()
    let id = this.element.id
    $(`#comment_reply_${id}`).addClass('d-none') // hide comment reply when post reply in comment
    setTimeout(() => {
      $('.comment_field').find('.ql-editor').html('')
    }, 500)
  }

  removeComment(e) {
    setTimeout(() => {
      $('.comment_reply').find('.ql-editor').html('')
    }, 500)
  }

  showReplyList(e) {
    e.preventDefault()

    const replies = $(`#comment_reply_${e.currentTarget.dataset.id}`)
    const scrollElement = e.target.closest('.layout-responsive')
    const scrollTop =
      scrollElement?.scrollTop ||
      globalThis.pageYOffset ||
      document.documentElement.scrollTop

    const active = document.activeElement
    active?.blur?.()

    e.target.textContent = replies.hasClass('d-none')
      ? 'Hide replies'
      : 'Show replies'

    replies.toggleClass('d-none')

    requestAnimationFrame(() => {
      scrollElement?.scrollTo({
        top: scrollTop,
        behavior: 'instant'
      })
    })
  }

  change_show_type(event) {
    const target = event.currentTarget
    const selectedValue = target.dataset.option
    const dropdownMenu = target.closest('.dropdown-menu')
    const dropdown = dropdownMenu?.closest('.dropdown')

    const shareTypesSpan = dropdown?.querySelector('.share_types')
    const checkboxes = dropdownMenu?.querySelectorAll('.form-check-input') || []

    const everyoneCheckbox = Array.from(checkboxes).find(
      (cb) => cb.dataset.option === 'everyone'
    )
    const onlyMeCheckbox = Array.from(checkboxes).find(
      (cb) => cb.dataset.option === 'only_me'
    )

    handleExclusiveSelection(
      selectedValue,
      checkboxes,
      everyoneCheckbox,
      onlyMeCheckbox
    )

    const selectedOptions = Array.from(checkboxes)
      .filter((cb) => cb.checked)
      .map((cb) => cb.nextElementSibling?.textContent.trim())
    shareTypesSpan.textContent =
      selectedOptions.join(', ') || 'Select Share Options'
    if (event.target?.dataset?.submit && selectedOptions.length > 0) {
      event?.target?.closest('form')?.requestSubmit()
    } else if (event.target?.dataset?.submit) {
      target.checked = true
      shareTypesSpan.textContent = target.dataset.option
    }
  }

  selectFile(e) {
    e.preventDefault()
    let index = e.currentTarget.dataset.index
    let target = document.getElementById('post_medias_' + index)
    $(target).removeClass('d-none')
    let filePound = this.FilePond.find(target)
    filePound.browse()
  }

  deletePost(event) {
    event.preventDefault()
    let id = $(this.element).find('.delete-post').attr('data-id')
    Swal.fire({
      customClass: {
        popup:
          'swal-popup alert-sm-bg align-items-center justify-content-center w-100',
        htmlContainer: 'text-black-paint text-white'
      },
      animation: false,
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        fetch('/posts/' + id, {
          method: 'DELETE',
          headers: {
            Accept: 'text/vnd.turbo-stream.html',
            'Content-Type': 'application/json'
          }
        })
          .then((r) => r.text())
          .then((response) => {
            globalThis.location.href = '/posts'
            Turbo.renderStreamMessage(response)
          })
      }
    })
  }

  createPoll(e) {
    let target = e.currentTarget
    let index = target.dataset.index
    $('#post-poll-' + index).removeClass('d-none')
    $(
      "input[name='user[posts_attributes][" +
        index +
        "][post_poll_attributes][_destroy]']"
    ).val(false)
    $(e.target).closest('form').find('#pollBtn').addClass('disabled')
  }

  removePoll(e) {
    let target = e.currentTarget
    let index = target.dataset.index
    $('#post-poll-' + index).addClass('d-none')
    $(
      "input[name='user[posts_attributes][" +
        index +
        "][post_poll_attributes][_destroy]']"
    ).val(true)
    let description = $(
      "div[data-name='user[posts_attributes][" + index + "][description]']"
    ).find('.ql-editor')
    $("input[name='user[posts_attributes][" + index + "][description]']").val(
      description?.html()
    )
    $('[data-action="click->nested-form#remove_association"]')
      .closest('.nested-fields')
      .remove()
    $(`#post-poll-${index} .nested-fields input`).val('')
    $(e.target).closest('form').find('#pollBtn').removeClass('disabled')
  }

  postPollFields(e) {
    const minSelect = document.querySelector('.min-field')
    if ($('.day-field').val() != 0 || $('.hr-field').val() != 0) {
      for (let i = 0; i < 5; i++) {
        minSelect.options[i].disabled = false
      }
    } else {
      minSelect.value = 5
      for (let i = 0; i < 5; i++) {
        minSelect.options[i].disabled = true
      }
    }
  }

  timeChanged(e) {
    const index = e.currentTarget.dataset.index
    const time = new Date(e.target.value)

    // Format for display (no seconds)
    const display = time.toLocaleString([], {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    })

    // Format ISO without seconds
    const isoWithoutSeconds =
      time.getFullYear() +
      '-' +
      String(time.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(time.getDate()).padStart(2, '0') +
      'T' +
      String(time.getHours()).padStart(2, '0') +
      ':' +
      String(time.getMinutes()).padStart(2, '0')

    $(`#schedule_time_${index}`).text(display)
    $(`#scheduled_at_${index}`).val(isoWithoutSeconds)
  }

  openLocationModal(event) {
    event.preventDefault()
    const index = event.currentTarget.dataset.index
    this.element.dataset.index = index

    const modalElement = $('#locationModal' + index)
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement)
      modal.show()
    } else {
      console.error('Location modal target not found!')
    }
  }

  openSchedule(event) {
    event.preventDefault()
    const index = event.currentTarget.dataset.index
    this.element.dataset.index = index

    const modalElement = $('#dateTimeModal' + index)
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement)
      modal.show()
    } else {
      console.error('Schedule modal target not found!')
    }
  }

  setLocation(e) {
    const idx = e.currentTarget.dataset.index
    if (idx) {
      const val = $(`#postLocation_${idx}`).val()
      if (!val) return
      $(`#location_${idx}`).html(`
        <div class="text-black-paint d-inline-flex align-items-center justify-content-start gap-2 text-white fs-20 p-font-bold py-2" id="location-1-${idx}">
          <span class="text-white">${val}</span>
          <a class="text-danger cursor-pointer" data-action="strip-post#removeLocation" data-key="1" data-index="${idx}">x</a>
          <input type="hidden" value="${val}" name="user[posts_attributes][${idx}][location]">
        </div>
      `)
    }
  }

  removeLocation(event) {
    event.preventDefault()
    const index = event.currentTarget.dataset.index
    const key = event.currentTarget.dataset.key
    $(`#location-${key}-${index}`).remove()
    $(`#postLocation_${index}`).val('')
  }

  checkForm(e) {
    e.preventDefault()
    e.currentTarget.classList.add('disabled')
    if (
      $(e.target)
        .closest('form')
        .find(
          "[name^='user[posts_attributes]'][name$='[share_post_option][]']:checked"
        ).length === 0 &&
      $(e.target).closest('form').find('.post-dropdown').length !== 0
    ) {
      alert('Please select at least one share option.')
    } else {
      const hiddenField = document.createElement('input')
      hiddenField.setAttribute('type', 'hidden')
      hiddenField.value = true
      hiddenField.setAttribute('name', 'create')
      this.element.closest('form').appendChild(hiddenField)
      this.element.closest('form').requestSubmit()
    }
  }

  // Called when Stimulus target "postList" is connected to DOM
  postListTargetConnected() {
    const posts = document.getElementById('post_list')
    if (!posts) return

    this.postsContainer = posts
    this.mutationObserver(posts)
  }

  mutationObserver(posts) {
    // Observe only structural changes in the post list container
    const config = { attributes: true, childList: true, subtree: true }

    this.observer = new MutationObserver((mutationsList) => {
      let shouldReorder = false
      for (const mutation of mutationsList) {
        if (mutation.type !== 'childList') continue

        for (const node of mutation.addedNodes) {
          if (!(node instanceof HTMLElement)) continue

          // ignore pagination frames completely
          if (node.tagName === 'TURBO-FRAME' && node.id?.includes('page-')) {
            continue
          }

          // Detect if new post elements are added (via class or nested structure)
          if (
            node.classList?.contains('repost_list_frame') ||
            node.querySelector?.('.repost_list_frame')
          ) {
            shouldReorder = true
            break
          }
        }
      }
      // Trigger reorder only when relevant post content is added
      if (shouldReorder) {
        this.reorderPosts(posts)
      }
    })

    this.observer.observe(posts, config)
  }

  reorderPosts(container) {
    // Collect all post elements currently in DOM
    const allPosts = Array.from(
      container.querySelectorAll('.repost_list_frame')
    )
    if (allPosts.length === 0) return

    const pinned = []
    const normal = []

    // Separate pinned and normal posts (NO DOM removal)
    for (const post of allPosts) {
      if (post.classList.contains('pinned_post')) {
        pinned.push(post)
      } else {
        normal.push(post)
      }
    }

    // Sort normal posts by timestamp (newest first)
    normal.sort((a, b) => {
      const aTime = Number(a.querySelector('.post-time')?.dataset?.time || 0)
      const bTime = Number(b.querySelector('.post-time')?.dataset?.time || 0)
      return bTime - aTime
    })

    // Identify pagination frame so we maintain correct insertion order
    const pagination = container.querySelector("turbo-frame[id^='page-']")
    this.observer.disconnect() // Temporarily disable observer to prevent infinite loop during DOM updates

    // Remove only post frames (NOT turbo frames)
    for (const post of allPosts) {
      post.remove()
    }

    // Reinsert pinned first, then normal posts
    const finalOrder = [...pinned, ...normal]

    for (const post of finalOrder) {
      if (pagination) {
        container.insertBefore(post, pagination)
      } else {
        container.appendChild(post)
      }
    }

    // Re-enable observer after DOM updates are complete
    this.observer.observe(container, {
      attributes: true,
      childList: true,
      subtree: true
    })
  }

  removePreview(e) {
    const previewEle = e.target.closest('.preview-link')
    const linkThumb = previewEle.parentElement
    const urlEle = linkThumb.nextElementSibling
    urlEle.value = ''
    urlEle.nextElementSibling.value = false
    previewEle.remove()
  }

  async closeForm(event) {
    const index = event.currentTarget.dataset.index
    const target =
      document.getElementById(`post_medias_${index}`) ||
      document.getElementById('new_message')
    let filePond
    const FilePond = await loadFilePond()
    filePond = FilePond.find(target)
    setTimeout(() => {
      if (filePond) {
        filePond.removeFiles()
      }
      $('#post-form').show()
      $('#post_section').hide()
    }, 100)
  }
}

function handleExclusiveSelection(
  selectedValue,
  checkboxes,
  everyoneCheckbox,
  onlyMeCheckbox
) {
  if (selectedValue === 'everyone') {
    uncheckAllExcept(checkboxes, everyoneCheckbox)
    return
  }

  if (selectedValue === 'only_me') {
    uncheckAllExcept(checkboxes, onlyMeCheckbox)
    return
  }

  uncheckExclusiveOptions(everyoneCheckbox, onlyMeCheckbox)
}

function uncheckAllExcept(checkboxes, allowedCheckbox) {
  for (const cb of checkboxes) {
    if (cb !== allowedCheckbox) {
      cb.checked = false
    }
  }
}

function uncheckExclusiveOptions(...checkboxes) {
  for (const cb of checkboxes) {
    if (cb?.checked) cb.checked = false
  }
}
